import React from 'react';
import { Dropdown } from 'react-bootstrap';
import QrCodeScanner from '@mui/icons-material/QrCodeScanner';
import RemoveCircleOutlineOutlined from '@mui/icons-material/RemoveCircleOutlineOutlined';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import MoreVert from '@mui/icons-material/MoreVert';
import './FinancialActionsMenu.css';

export const FinancialActionsMenu = ({
  isPixPaymentEnabled,
  isPixLoading,
  onPayWithPix,
  isClientAccessControlEnabled,
  isClientAccessBlocked,
  onToggleClientAccess,
  canCancelPlan,
  onCancelPlan,
}) => (
  <Dropdown alignRight>
    <Dropdown.Toggle
      bsPrefix="financial-actions-toggle"
      variant="link"
      className="btn btn-icon"
      style={{ borderColor: '#D1D3E0' }}
      id="financial-actions-toggle"
    >
      <MoreVert style={{ color: 'black' }} />
    </Dropdown.Toggle>
    <Dropdown.Menu className="dropdown-menu">
      {isPixPaymentEnabled && (
        <Dropdown.Item
          className="d-flex align-items-center"
          style={{ borderBottom: '1px solid #EBEDF3' }}
          onClick={onPayWithPix}
          disabled={isPixLoading}
        >
          <QrCodeScanner fontSize="small" className="mr-2" />
          Pagar com Pix
        </Dropdown.Item>
      )}
      {isClientAccessControlEnabled && (
        <Dropdown.Item
          className="d-flex align-items-center"
          style={{ borderBottom: '1px solid #EBEDF3' }}
          onClick={onToggleClientAccess}
        >
          <RemoveCircleOutlineOutlined fontSize="small" className="mr-2" />
          {isClientAccessBlocked ? 'Desbloquear acesso' : 'Bloquear acesso'}
        </Dropdown.Item>
      )}
      {canCancelPlan && (
        <Dropdown.Item
          className="d-flex align-items-center text-danger"
          onClick={onCancelPlan}
        >
          <DeleteOutline fontSize="small" className="mr-2" />
          Cancelar plano
        </Dropdown.Item>
      )}
    </Dropdown.Menu>
  </Dropdown>
);
